import { makeStyles } from "tss-react/mui";

import { OtaFile } from "@dashboard/rollouts/types";
import { Tag } from "@dashboard/shared/components/Tag/Tag";
import { getTagReactKey, sortTags } from "@dashboard/shared/tags";
import { Box, Theme } from "@mui/material";

const useStyles = makeStyles()((theme: Theme) => ({
    row: {
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        gap: theme.spacing(1),
        marginTop: theme.spacing(1),
    },
}));

type Props = {
    otaFile: OtaFile;
};

export const VersionMeta = ({ otaFile }: Props) => {
    const { classes } = useStyles();

    const userTags = sortTags(
        Object.entries(otaFile.annotation?.metadata?.user ?? {}).map(([key, value]): API.Tag => ({
            key,
            value,
            type: value ? "scoped" : "simple",
        })),
    );
    const generatedTags = sortTags<API.Tag>([
        { key: "version", value: otaFile.version, type: "scoped" },
        { key: "channel", value: otaFile.channel ?? "none", type: "scoped" },
    ]);

    return (
        <Box className={classes.row}>
            {userTags.map((tag) => (
                <Tag key={getTagReactKey(tag)} item={tag} />
            ))}
            {generatedTags.map((tag) => (
                <Tag key={getTagReactKey(tag)} item={tag} theme="light" />
            ))}
        </Box>
    );
};
